module.exports = __webpack_public_path__ + "img/expl-selfie-3.f9a7c25d.svg";